import { defineMigrations } from "@supersig/store";
/** @public */ export const inputNodeProps = {};
/** @internal */ export const inputNodeMigrations = defineMigrations({});
export const InputNodeInfo = {
    migrations: inputNodeMigrations,
    props: inputNodeProps,
    meta: {}
};
